"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _PatternBaseGLFilter = _interopRequireDefault(require("./PatternBaseGLFilter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class PatternTwelveFoldReflectedGLFilter extends _PatternBaseGLFilter.default {
  constructor() {
    const fsSource = `
        precision mediump float;

        uniform sampler2D t_tex;
        varying highp vec2 v_uv;
        uniform float zoom;
        uniform float aspect;
        uniform bool greyScale;
        uniform float greyLevels;
        uniform float blackWhiteThreshold;  //black to white boundary range -1.0 - 1.0

        void main(void)
        {
            const float segments = 12.;
            const float pi = 3.1415926535;
            const float segmentAngle = 2. * pi / segments;

            const float horizontalCentering = 0.158;

            const float tan60 = tan(pi / 3.);
            const float centerWidth = 1. / sin(pi / 3.);
            const float sideWidth = 1. / tan60;
            const float totalWidth = 2. * sideWidth + 2. * centerWidth;
            const float halfHeight = 1.0;
            const float totalHeight = 2. * halfHeight;
            const float middleCenterX = sideWidth + centerWidth / 2.;
            const float rightCenterX = 2. * sideWidth + 1.5 * centerWidth;
            const float leftCenterX = -1. * centerWidth / 2.0;

            float zoomTotal = zoom * 2.;
            vec2 p = zoomTotal * v_uv;

            vec2 pt;
            // code for zooming from center and aspect ratio correction
            if(aspect >= 1.)
            {
                float longEdgeOffsetBigAspectX = mod(zoomTotal * aspect, totalWidth * 2.) / 2.;
                float longEdgeOffsetBigAspectY = mod(zoomTotal, totalHeight * 2.) / 2.;
                pt.x = mod ( p.x * aspect + (1. - longEdgeOffsetBigAspectX) + horizontalCentering, totalWidth );
                pt.y = mod ( p.y + (1. - longEdgeOffsetBigAspectY), totalHeight );
            }
            else
            {
                float longEdgeOffsetSmallAspectX = mod(zoomTotal, totalWidth * 2.) / 2.;
                float longEdgeOffsetSmallAspectY = mod(zoomTotal / aspect, totalHeight * 2.) / 2.;
                pt.x = mod ( p.x + (1. - longEdgeOffsetSmallAspectX) + horizontalCentering, totalWidth );
                pt.y = mod ( p.y / aspect + (1. - longEdgeOffsetSmallAspectY), totalHeight );
            }

            vec2 pio = p - pt; // origin of tile

            vec2 pc; // center of hexagon (in tile)

            // four cases, based on x:
            // this can be done with a lot less compares
            // just use some nice sawtooths, the whole thing could be done without compares
            if ( pt.x < sideWidth ) {
                // strip 1:   /  three possible centers
                //
                if ( pt.y < halfHeight ) {
                    if ( pt.y > halfHeight - pt.x * tan60 )
                        pc = vec2 ( middleCenterX, halfHeight );
                    else
                        pc = vec2 ( leftCenterX, 0.0 );
                } else {
                    if ( pt.y - halfHeight < pt.x * tan60 )
                        pc = vec2 ( middleCenterX, halfHeight );
                    else
                        pc = vec2 ( leftCenterX, totalHeight );
                }
            } else if ( pt.x < centerWidth + sideWidth ) {
                // strip 2:   -   center is always in the middle
                //            -
                pc = vec2 ( middleCenterX, halfHeight );
            } else if ( pt.x < centerWidth + 2. * sideWidth ) {
                // strip 3:   -  three possible centers
                //            -
                if ( pt.y < halfHeight ) {
                    if ( pt.y > (pt.x - (sideWidth + centerWidth)) * tan60 )
                        pc = vec2 ( middleCenterX, halfHeight );
                    else
                        pc = vec2 ( rightCenterX, 0.0 );
                } else {
                    if ( pt.y - halfHeight < halfHeight - (pt.x - (sideWidth + centerWidth)) * tan60 )
                        pc = vec2 ( middleCenterX, halfHeight );
                    else
                        pc = vec2 ( rightCenterX, totalHeight );
                }
            } else { // pt.x < totalWidth
                // strip 4:    _   center is up or down depending on y
                //
                if ( pt.y < halfHeight )
                    pc = vec2 ( rightCenterX, 0 );
                else
                    pc = vec2 ( rightCenterX, totalHeight );
            }

            // bring pc from tile to screen
            pc += pio;

            // now we can use pc to round our original point
            vec2 ph = p - pc;

            // cartesian to polar coordinates
            float r = length(ph);
            float theta = atan(ph.y, ph.x);

            float region = segments * (theta + pi) / (2. * pi);
            float k = fract(region) * segmentAngle;

            // flip alternate segments
            float intRegion = region - fract(region);
            if(mod(intRegion, 2.) == 0.)
            {
                k = segmentAngle - k;
            }

            // polar to cartesian coordinates
            p = r * vec2(cos(k), sin(k));

            // adjustments to get the desired part of the image in the sampling area
            p = p * 0.85;
            p.y += .29;
            p.x += .07;
            if(greyScale == true) {
                vec4 texColor = texture2D(t_tex, p);
                int bitGrey = int((0.21 * texColor.x + 0.72 * texColor.y + 0.07 * texColor.z) * greyLevels + blackWhiteThreshold);
                float grey = (float(bitGrey) / (greyLevels - 1.));
                gl_FragColor = vec4(grey, grey, grey, 1.0);
            }
            else {
                gl_FragColor = texture2D(t_tex, p);
            }

            //debugging!
            //gl_FragColor = vec4(k / 6., 0., 0., 1.);
        }
        `;
    super(fsSource);
  }

}

exports.default = PatternTwelveFoldReflectedGLFilter;